/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

const useEvent = (elementOrRef, eventName, callback) => {
  const savedCallback = React.useRef(null);
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  React.useEffect(() => {
    const handler = event => {
      if (savedCallback.current) {
        savedCallback.current(event);
      }
    };
    const element = 'current' in elementOrRef ? elementOrRef.current : elementOrRef;
    element?.addEventListener(eventName, handler);
    return () => {
      element?.removeEventListener(eventName, handler);
    };
  }, [elementOrRef, eventName]);
};
const useWindowEvent = (eventName, callback) => {
  const savedCallback = React.useRef(null);
  React.useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  React.useEffect(() => {
    const handler = event => {
      if (savedCallback.current) {
        savedCallback.current(event);
      }
    };
    window.addEventListener(eventName, handler);
    return () => {
      window.removeEventListener(eventName, handler);
    };
  }, [eventName]);
};

exports.useEvent = useEvent;
exports.useWindowEvent = useWindowEvent;
